import { action } from 'typesafe-actions';

import { CurrentModuleTypes } from './types';

// Set currentModule
export const setCurrentModule = (payload: { module: string }) =>
  action(CurrentModuleTypes.SET_CURRENT_MODULE, payload);
